import React from 'react'
import { useState, useMemo } from 'react'

interface SidebarMenuProviderValue {
  hidden: boolean
  actions: {
    openMenu: () => void
    closeMenu: () => void
  }
}

const SidebarMenuContext = React.createContext<SidebarMenuProviderValue | null>(null)

const SidebarMenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hidden, setHidden] = useState(true)

  const value = useMemo<SidebarMenuProviderValue>(
    () => ({
      hidden,
      actions: {
        openMenu: () => setHidden(false),
        closeMenu: () => setHidden(true),
      },
    }),
    [hidden],
  )

  return <SidebarMenuContext.Provider value={value}>{children}</SidebarMenuContext.Provider>
}

export { SidebarMenuProvider, SidebarMenuContext }
